export default "__VITE_ASSET__BOBH$rBU__"